import { useBasket } from '@components/BasketProvider'
import ConditionalRoute from '@whitecobalt/tungsten/esm/components/ConditionalRoute'
import { useSession } from '@whitecobalt/tungsten/esm/components/Session'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { DoorCoreView, ProductView, SealProductView, MasterProductView } from '..'
import DoorCoreList from './DoorCoreList'
import AllDoorCoreList from './DoorCoreList/All'
import HardwareList from './HardwareList'
import AllHardwareList  from './HardwareList/All'
import AllSealList from './SealProducts/All'
import AllOtherItem from './OtherAccessoryList/All'
import OtherAccessoryList from './OtherAccessoryList'
import ProductListContainer from './Prefabs/ProductListContainer'
import SealsList from './SealsList'
import SearchList from './SearchList'
import SealProducts from './SealProducts'
import MasterProducts from './MasterProducts'
import shopLinks  from './shopLinks'
interface ProductListProps {
    
}

const ProductList: React.FunctionComponent<ProductListProps> = (props) => {
    const basket = useBasket()

    const ProductDescription = {
        Other_Accessories : "",
        AllHardware:"A full range of Halspan hardware suitable for fire and non-fire rated applications for the fabrication of doorsets or door assemblies. The essential fire rated hardware components have been tested and assessed in conjunction with our door blanks and intumescent seals offering compliance and peace of mind.",
        AllSeals:"Intumescent seals are another vital part of fit-for-purpose doorsets. Choose from a range of acoustic, fire and smoke, and threshold seals designed to meet specific performance requirements.",
        AllCores: "Select from a range of fire and non-fire rated door blanks and cores tested to satisfy BS, EN, IS and UL test standards. From Halspan’s unique 3-layer particle board door blanks for internal use or our 3-layer solid core faced with either exterior grade plywood for exterior use or MDF for indoor applications to our fire rated mineral core range for internal use.",
        AllOtherProducts:"",
        hinges_plates: "A range of standard pull handles and finger plates provided in satin stainless steel finish where durability and a clean appearance are important. Also available with an anti-microbial finish.",
        letterplates: "Fire and non-fire rated letterplates compliant with TS008 PAS24 and Halspan fire certification",
        cylinders: "3* cylinders compliant with TS007 PAS24 and Halspan fire certification.",
        ancillary_items: "A range of complementary hardware to aid functionality and security.",
        Signage : "New signage products coming soon!",
        seals : "Intumescent seals are a vital part of fit-for-purpose doorsets.  Choose from a range of acoustic, fire and smoke, threshold seals and intumescent hardware kits, designed to meet specific performance requirements.",
        fire_smoke : "The Halspan range of fire and smoke seals have been developed to compliment our range of fire rated door cores and door systems. Fully tested to BS476: Part 22 1987 and BS EN 1634: Part 1: 2008.",
        acoustic : "The Halspan range of acoustic seals, offers a comprehensive range of solutions that exceed regulatory acoustic performance requirements.",
        kits : "The Halspan range of seal kits, draw from our full range of seals, to provide a set of components to seal a door.",
        glazing: "The Halspan range of glazing seals, are available to compliment our door cores and door systems whilst supporting a range of leading glass types.",
        lock_protection : "The Halspan range of lock protection, is a fully tested range of intumescents tested in conjunction with our door cores and door system.",
        hinge_protection : "The Halspan range hinge protection, is a fully tested range of intumescents tested in conjunction with our door cores and door system.",
        closer_protection : "The Halspan range of lock protection, is a fully tested range of intumescents tested in conjunction with our door cores and door system.",
        closer: "The Halspan range of closers are efficient, durable and stylish. Suitable for most applications, particularly those in constant use and which require a backcheck function.",
        hinges: "The Halspan range of hinges provides strength and durability to compliment our full range of door cores and door systems. Fully certified and backed by our extensive test evidence.",
        locks: "The Halspan range of locks, have been specifically tested in our door cores along with our intumescent kits to ensure compliance. They offer durability, strength and ease of use.",
        particle_board: "Rated at 20, 30 to 120 minutes’ fire resistance, our range of internal fire door blanks includes Optima, Prima and our even greener Prima Plus alternative. Also made from Halspan’s unique 3-layer particle board, Veria is our internal non-fire door blank.",
        timber_core : "Rated at 30 and 60 minutes’ fire resistance, our solid timber core fire door blanks are made from a 3-layer solid core faced with either exterior grade plywood for fully exposed exterior conditions or MDF for indoor applications.",
        mineral_core : "Rated at 90 and 120 minutes’ fire resistance, our mineral core fire door blanks are engineered  and to meet a range of testing and certification requirements.",
        grill : "A range of air transfer grills coming soon!",
        smart_tag : "Halspan Smart Tags - with Near Field Communication technology readable via Halspan Tracker app on Apple or Android mobile devices."
    } as any
        

    return (
        <ProductListContainer>
            <Switch>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/door-core/view/:id/:pID?"
                        component={DoorCoreView}
                        exact/>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/product/view/:id"
                        component={ProductView}
                        exact/>  
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/master-product/master/:id/type/:typeID"
                        component={MasterProductView}
                        exact/>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/master-product/master/:id/type/:typeID/view/:productID"
                        component={MasterProductView}
                        exact/>       
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/master/:id"
                        component={SealProductView}
                        exact/>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/master/:id/view/:productID"
                        component={SealProductView}
                        exact/>           
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/core"
                        exact
                >
                        <AllDoorCoreList 
                                key="3-layer-particle-boards" 
                                shopLinks={shopLinks.cores}
                                productTypeURL={"/store/core"}
	                        productCategoryURL={"/store/core"}
                                menuDescription={ProductDescription.AllCores} 
                        />
                </ConditionalRoute>                 
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/core/3-layer-particle-boards"
                        exact>
                        <DoorCoreList 
                                key="3-layer-particle-boards" 
                                type="3-layer-particle-boards"  
                                menuDescription={ProductDescription.particle_board}
                                shopLinks={shopLinks.cores}
                                productTypeURL={"/store/core"}
	                        productCategoryURL={"/store/core/3-layer-particle-boards"}
                        />
                </ConditionalRoute>                                
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/core/solid-timber-cores"
                        exact>
                        <DoorCoreList 
                                key="solid-timber-cores" 
                                type="solid-timber-cores"
                                menuDescription={ProductDescription.timber_core}  
                                shopLinks={shopLinks.cores}
                                productTypeURL={"/store/core"}
                                productCategoryURL={"/store/core/solid-timber-cores"}
                        />
                </ConditionalRoute>                                
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/core/mineral-cores"
                        exact>
                        <DoorCoreList 
                                key="mineral-cores" 
                                type="mineral-cores" 
                                menuDescription={ProductDescription.mineral_core}  
                                shopLinks={shopLinks.cores}
                                productTypeURL={"/store/core"}
	                        productCategoryURL={"/store/core/mineral-cores"}
                        />
                </ConditionalRoute>                              
                <Redirect path="/store/cores" to="/store/core"/>  
                <Redirect path="/store/cores/" to="/store/core"/>  
                <Redirect path="/store/core/" to="/store/core"/>  
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal"
                        exact>
                        <AllSealList 
                                menuDescription={ProductDescription.AllSeals} 
                                shopLinks={shopLinks.seals}
                                productTypeURL={"/store/seal"}
	                        productCategoryURL={"/store/seal"}
                        />
                </ConditionalRoute>                                                   
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/fire"
                        exact>
                        <SealProducts 
                                key="fire" 
                                type="fire"  
                                menuDescription={ProductDescription.seals} 
                                shopLinks={shopLinks.seals}
                                productTypeURL={"/store/seal"}
	                        productCategoryURL={"/store/seal/fire"}
                                />
                </ConditionalRoute>                                    
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/fire-smoke"
                        exact>
                        <SealProducts 
                                key="fire-smoke" 
                                type="fire-smoke"  
                                menuDescription={ProductDescription.fire_smoke} 
                                shopLinks={shopLinks.seals}
                                productTypeURL={"/store/seal"}
	                        productCategoryURL={"/store/seal/fire-smoke"}
                        />
                </ConditionalRoute>                                    
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/acoustic"
                        exact>
                        <SealProducts 
                                key="acoustic" 
                                type="acoustic"  
                                menuDescription={ProductDescription.acoustic} 
                                shopLinks={shopLinks.seals}
                                productTypeURL={"/store/seal"}
	                        productCategoryURL={"/store/seal/acoustic"}
                        />
                </ConditionalRoute>                                    
                {/* <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/weather"
                        exact>
                        <SealProducts key="weather" type="weather" />
                </ConditionalRoute>                                     */}
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/kits"
                        exact>
                        <MasterProducts 
                                key="kits" 
                                type="kits" 
                                menuDescription={ProductDescription.kits}  
                                shopLinks={shopLinks.seals} 
                                productTypeURL={"/store/seal"}
                                productCategoryURL={"/store/seal/hinges"}
                        />
                </ConditionalRoute>                                    
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/glazing"
                        exact>
                        <MasterProducts 
                                key="glazingSeals" 
                                type="glazingSeals" 
                                menuDescription={ProductDescription.glazing}  
                                shopLinks={shopLinks.seals} 
                                productTypeURL={"/store/seal"}
                                productCategoryURL={"/store/seal/hinges"}
                        />
                </ConditionalRoute>   
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/closer-protections"
                        exact>
                        <OtherAccessoryList 
                                key="closer-protection" 
                                type="closer-protection" 
                                menuGroup='Seals' 
                                menuDescription={ProductDescription.closer_protection} 
                                shopLinks={shopLinks.seals}
                                productTypeURL={"/store/seal"}
	                        productCategoryURL={"/store/seal/closer-protections"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/hinge-protections"
                        exact>
                        <OtherAccessoryList 
                                key="hinge-protection" 
                                type="hinge-protection" 
                                menuGroup='Seals' 
                                menuDescription={ProductDescription.hinge_protection} 
                                shopLinks={shopLinks.seals}
                                productTypeURL={"/store/seal"}
	                        productCategoryURL={"/store/seal/hinge-protections"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/lock-protections"
                        exact>
                        <OtherAccessoryList 
                                key="lock-protection" 
                                type="lock-protection" 
                                menuGroup='Seals' 
                                menuDescription={ProductDescription.lock_protection} 
                                shopLinks={shopLinks.seals}
                                productTypeURL={"/store/seal"}
	                        productCategoryURL={"/store/seal/lock-protections"}
                        />
                </ConditionalRoute>
                <Redirect path="/store/seal/" to="/store/seal/fire"/>   
                <Redirect path="/store/seals" to="/store/seal/fire"/> 
                <Redirect path="/store/seals/" to="/store/seal/fire"/> 
                {/* <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/seal/:id"
                        component={SealProductView}
                        exact/>          */}
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware"
                        exact>
                        <AllHardwareList 
                                key="allHardware" 
                                shopLinks={shopLinks.hardwares} 
                                menuDescription={ProductDescription.AllHardware} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware/closers"
                        exact>
                        <MasterProducts 
                                key="closers" 
                                type="closers" 
                                menuDescription={ProductDescription.closer} 
                                shopLinks={shopLinks.hardwares} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware/closers"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware/cylinders"
                        exact>
                        <MasterProducts 
                                key="Cylinders" 
                                type="cylinders" 
                                menuDescription={ProductDescription.cylinders} 
                                shopLinks={shopLinks.hardwares} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware/cylinders"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware/letterbox"
                        exact>
                        <MasterProducts 
                                key="letterbox" 
                                type="letterbox"  
                                shopLinks={shopLinks.hardwares} 
                                menuDescription={ProductDescription.letterplates} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware/letterbox"}
                        />
                </ConditionalRoute>                               
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware/hinges"
                        exact>
                        <MasterProducts 
                                key="hinges" 
                                type="hinges" 
                                menuDescription={ProductDescription.hinges}  
                                shopLinks={shopLinks.hardwares} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware/hinges"}
                        />
                </ConditionalRoute>                        
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware/locks"
                        exact>
                        <MasterProducts 
                                key="locks" 
                                type="locks" 
                                menuDescription={ProductDescription.locks}  
                                shopLinks={shopLinks.hardwares} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware/locks"}
                        />
                </ConditionalRoute>                  
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware/handles-finger-plates"
                        exact>
                        <MasterProducts 
                                key="handlesFingerPlates" 
                                type="handlesFingerPlates" 
                                shopLinks={shopLinks.hardwares} 
                                menuDescription={ProductDescription.hinges_plates} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware/handles-finger-plates"}
                        />
                </ConditionalRoute> 
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/hardware/ancillary-items"
                        exact>
                        <MasterProducts 
                                key="others" 
                                type="others" 
                                shopLinks={shopLinks.hardwares} 
                                productTypeURL={"/store/hardware"}
	                        productCategoryURL={"/store/hardware/ancillary-items"}
                                menuDescription={ProductDescription.ancillary_items} 
                        />
                </ConditionalRoute>
                <Redirect path="/store/hardware/" to="/store/hardware"/>                                             
                <Redirect path="/store/hardwares" to="/store/hardware"/>    
                <Redirect path="/store/hardwares/" to="/store/hardware"/>                                             
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/signage"
                        exact>
                        <OtherAccessoryList 
                                key="signage" 
                                type="signage"  
                                menuDescription={ProductDescription.signage} 
                                shopLinks={shopLinks.signage} 
                                productTypeURL={"/store/signage"}
	                        productCategoryURL={"/store/signage"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/smart-tags"
                        exact>
                        <OtherAccessoryList 
                                key="smart-tags" 
                                type="smart-tags"
                                menuDescription={ProductDescription.smart_tag}  
                                shopLinks={shopLinks.smartTags}
                                productTypeURL={"/store/smart-tags"}
	                        productCategoryURL={"/store/smart-tags"}
                        />
                </ConditionalRoute>
                <Redirect path="/store/smart-tag/" to="/store/smart-tags"/>  
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/other-products"
                        exact>
                        <AllOtherItem 
                                key="AllOtherProducts" 
                                shopLinks={shopLinks.other_products} 
                                menuDescription={ProductDescription.AllOtherProducts} 
                                productTypeURL={"/store/other-products"}
	                        productCategoryURL={"/store/other-products"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/other-products/closer-protection"
                        exact>
                        <OtherAccessoryList 
                                key="closer-protection" 
                                type="closer-protection"
                                menuDescription={ProductDescription.closer_protection}  
                                shopLinks={shopLinks.other_products}
                                productTypeURL={"/store/other-products"}
	                        productCategoryURL={"/store/other-products/closer-protection"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/other-products/hinge-protection"
                        exact>
                        <OtherAccessoryList 
                                key="hinge-protection" 
                                type="hinge-protection"
                                menuDescription={ProductDescription.hinge_protection}  
                                shopLinks={shopLinks.other_products}
                                productTypeURL={"/store/other-products"}
	                        productCategoryURL={"/store/other-products/hinge-protection"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/other-products/lock-protection"
                        exact>
                        <OtherAccessoryList 
                                key="lock-protection" 
                                type="lock-protection"
                                menuDescription={ProductDescription.lock_protection}  
                                shopLinks={shopLinks.other_products}
                                productTypeURL={"/store/other-products"}
	                        productCategoryURL={"/store/other-products/lock-protection"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/other-products/air-transfer-grill"
                        exact>
                        <OtherAccessoryList 
                                key="air-transfer-grill" 
                                type="air-transfer-grill"
                                menuDescription={ProductDescription.grill}  
                                shopLinks={shopLinks.other_products}
                                productTypeURL={"/store/other-products"}
	                        productCategoryURL={"/store/other-products/air-transfer-grill"}
                        />
                </ConditionalRoute>
                    <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/other-products/accessories"
                        exact>
                        <OtherAccessoryList 
                                key="accessories" 
                                type="accessories"
                                menuDescription={ProductDescription.Other_Accessories}  
                                shopLinks={shopLinks.other_products}
                                productTypeURL={"/store/other-products"}
	                        productCategoryURL={"/store/other-products/accessories"}
                        />
                </ConditionalRoute>
                <ConditionalRoute
                        condition={!basket.states.hasOverlapBasket}
                        redirectTo="/store/overlap-basket"
                        path="/store/search/:searchText"
                        exact>
                        <SearchList/>
                </ConditionalRoute>
                <Route path="*" render={() => { 
                        window.location.assign('https://halspan.com/404') 
                        return null
                }}/>   
            </Switch>
        </ProductListContainer>
    )
}

export default ProductList
